import {
  createPinia,
  setActivePinia
} from "pinia"
import '@/css/tailwind.css'
import 'uno.css'
import SplashScreen from '@/views/SplashScreen.vue'
import { createApp } from 'vue'

const appNode = '#app'
const loadingNode = '#loading'
const routerReadyCapMs = 2000

// The app mounts under the splash, which then fades out over it: no white gap between the two.
const mountApp = async () => {
  const loadingApp = createApp(SplashScreen)
  const splash = loadingApp.mount(loadingNode) as InstanceType<typeof SplashScreen>

  // Modules under mainApp, such as the router guards, call stores as they load.
  const pinia = createPinia()
  setActivePinia(pinia)

  const mainApp = await import('./mainApp')
  const mainAppInstance = await mainApp.createApp(pinia)
  mainAppInstance.mount(appNode)

  // Fade onto the resolved first page, but never hold the splash on a navigation a guard leaves pending.
  const { getRouter } = await import('@/router/router')
  await Promise.race([
    getRouter().isReady().catch(() => undefined),
    new Promise(resolve => setTimeout(resolve, routerReadyCapMs))
  ])

  await splash.beforeUnload()
  loadingApp.unmount()
}

mountApp()
